import { connect } from 'react-redux';

// Utils and Services
import fetchCSVReport from '../../store/report';
import { resetCreatePto } from '../../store/createOrder';

import SearchTopBar from './TopBar';

const mapDispatch = {
  fetchCSVReport,
  resetCreatePto,
};

export default connect(null, mapDispatch)(SearchTopBar);
